import fp from 'micro-fp';

export default function formatDate(dateFilter) {
  'ngInject';

  return fp.curry((format, date) => dateFilter(date, format));
}
